import React from 'react';
import { IconProps } from '.';

const SvgHandshake = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M6.625 5.457a.75.75 0 0 1 .518-.207h8a.75.75 0 0 1 .518.207l2.068 1.975h5.021v8.045h-2.307l.357.341-2.854 2.725a.75.75 0 0 1-1.035 0L15.714 17.4l-1.196 1.142a.75.75 0 0 1-1.036 0L12.286 17.4l-1.197 1.142a.75.75 0 0 1-1.035 0l-3.212-3.066H1.25V7.432h3.307l2.068-1.975Zm12 10.358-5.196-4.96-1.768 1.688a.75.75 0 0 1-1.036 0L7.768 9.815a.75.75 0 0 1 0-1.085l2.074-1.98H7.443L5.158 8.932H2.75v5.045h4.693l3.128 2.986 1.197-1.142a.75.75 0 0 1 1.036 0L14 16.963l1.196-1.142a.75.75 0 0 1 1.036 0l1.197 1.142 1.2-1.145-.004-.003Zm-6.61-9.065L9.372 9.273l1.77 1.69 2.287-2.182 5.443 5.196h2.378V8.932h-4.122L14.842 6.75h-2.827Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgHandshake;
